import React from 'react'
import './nav.css'
import {AiOutlineHome} from 'react-icons/ai'
import {BiUser} from 'react-icons/bi' 
import {BsBriefcase} from 'react-icons/bs'
import {RiServiceLine} from 'react-icons/ri'
import {IoMdContact} from 'react-icons/io'
import { useState } from 'react'

const Nav = () => {
 
  const [activeNav, setActiveNav] = useState('#home')
  return (
    <nav >
      <a href="#home" onClick={() =>setActiveNav('#home') } className={activeNav === "#home" ? 'active' : ' '} ><AiOutlineHome /></a>
      <a href="#about" onClick={() =>setActiveNav('#about') } className={activeNav === "#about" ? 'active' : ' '}><BiUser /></a>
      <a href="#services"  onClick={() =>setActiveNav('#services') } className={activeNav === "#services" ? 'active' : ' '} ><RiServiceLine /></a>
      <a href="#portfolio"  onClick={() =>setActiveNav('#portfolio') } className={activeNav === "#portfolio" ? 'active' : ' '} ><BsBriefcase /></a>
      <a href="#contact"  onClick={() =>setActiveNav('#contact') } className={activeNav === "#contact" ? 'active' : ' '}><IoMdContact /></a>
    </nav>
  )
}

export default Nav